import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("hr");

export const hrTransport = transport;
export const HR_BASE_URL = baseUrl;
